import { HTTP } from '../../shared/http-common';
import axios from 'axios';

export default {
  name: 'UsernameChange',
  data() {
    return {
      uuid: this.$route.query.uuid,
      token: this.$route.query.token,
      password: null,
      usernameChangeStatusMessage: null,
      usernameChangeStatusSuccess: false,
      isBusy: false,
      validationResultsError: null
    }

  },
  computed: {
  },
  methods: {

    changeUsername(e) {
        this.changeUsernameRequest(process.env.BASE_URL + process.env.USER_CHANGE_PASSWORD_ENDPOINT + '/' + this.uuid + '/' + process.env.VALIDATE_USERNAME_CHANGE_ENDPOINT + '/' + this.token);
    },

    /**
     * Change password
     * @param {*} url
     *
     */
    changeUsernameRequest(url) {
      this.isBusy = true;
      HTTP.post(url, this.password, {
        headers: { 'Content-Type': 'text/plain' }
      }).then(response => {
        this.isBusy = false;

      if (response.status !== 204) {
        this.displayUsernameChangeStatus(false, response.data)
      } else {
        this.displayUsernameChangeStatus(true)
        this.password = null;
      }
      this.isBusy = false;
    })
    .catch(error => {
        this.displayUsernameChangeStatus(false, error.response.data);
      this.isBusy = false;
    });
    },


    /**
     *
     * @param success
     * @param errorMessageData
     */

    displayUsernameChangeStatus(success, errorMessageData) {
      this.usernameChangeStatusSuccess = success;
      var message = success ? "Email address successfully changed" : "There was an error changing the email address. Reason: "
      this.usernameChangeStatusMessage = (errorMessageData ? message + errorMessageData.message : message) + ". ";
      if (errorMessageData.hasOwnProperty('details') && errorMessageData.details.length > 0) {
        this.usernameChangeStatusMessage += errorMessageData.details[0].message;
      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/UsernameChange/UsernameChange.js